<template>
  <section id="products" class="proposal-page__section products">
    <div class="pp-container --is-narrow">
      <header class="proposal-page__section-heading">
        <h2 class="proposal-page__section-title">{{ data.products_title }}</h2>
        <p class="proposal-page__section-description" v-html="data.products_text"></p>
      </header>
    </div>

    <div class="pp-container --is-narrow">
      <ul class="products__list">
        <li class="products__item" v-for="product in data.products" :key="product.id">
          <article>
            <div class="products__card">
              <!-- <img src="@/assets/images/landing-page/flags/nl.svg" class="products__flag"> -->

              <div class="products__photo-wrap">
                <img
                  :src="`${product.image[0].replace('componata.de', 'cdn.componata.de')}?format=${webPFormat('jpeg')}&width=400&quality=80`" class="products__photo"
                  :alt="product.name"
                >
              </div>

              <div class="products__info">
                <h3 class="products__title">{{ product.name }}</h3>
                <p class="products__description">
                  {{ product.base_product }}
                  <span v-if="product.taste !== '' && product.taste !== '0'"
                  >&nbsp;· {{ product.taste }}</span
                  >
                </p>
                <p class="products__brand">von {{ product.manufacturer }}</p>
              </div>
            </div>
          </article>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { helperMixin } from '@/mixins/HelperMixin';

export default {
  name: 'Products',
  mixins: [helperMixin],
  props: ['data']
};
</script>

<style lang="scss" scoped>
/**
 * Products
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Product listing for the Present Box
 * @since 2020-10-28
**/

$component: 'products';

.#{$component} {
  background-color: $white;

  // Products grid
  &__list {
    @include unlist;

    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    display: flex;
    flex: 0 1 30%;
    margin-bottom: 5%;

    &:not(:nth-child(3n)) {
      margin-right: 5%;
    }
  }

  // Product's card
  &__card {
    display: block;
    @include padding(map-get($spacers, 4));
    border-radius: $border-radius-lg;
    box-shadow: 7px 9px 14px 3px rgba(black, 0.04);
    color: $ink;
  }

  &__photo-wrap {
    @include margin-bottom(map-get($spacers, 4));
    max-width: 100%;
  }

  &__photo {
    max-width: 100%;
  }

  &__title {
    @include font-size(map-get($proposal-page, 'font-size-lg'));
  }

  &__description {
    @include margin-bottom(map-get($spacers, 1));
    color: $ink-lighter;
    line-height: 140%;
  }

  &__brand {
    color: $ink-lighter;
    @include font-size(map-get($proposal-page, 'font-size-sm'));
  }

  // The whole present promo
  &__present {
    @include margin-top(map-get($spacers, 6) * 2);
    @include padding(map-get($spacers, 4));
    border-radius: $border-radius-lg;
    box-shadow: 7px 9px 14px 3px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(151, 151, 151, 0.49);
  }

  &__present-photo {
    width: 60%;
    // margin-top: auto;
    @include margin-top(- map-get($spacers, 3) * 3);
    @include margin-bottom(- map-get($spacers, 4));
    margin-bottom: auto;
  }

  ::v-deep .postcard-thumbnails {
    width: 100%;
  }

  &__present-title {
    @include margin-bottom(map-get($spacers, 4));
    @include font-size(map-get($proposal-page, 'font-size-lg'));
    font-weight: $font-weight-normal;

    b {
      display: block;
      font-weight: 600;
    }
  }

  &__present-cta {
    display: flex;
    justify-content: space-between;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-sm')) {
    &__item {
      display: flex;
      flex: 0 1 45%;
      margin-bottom: 5%;
      margin-right: 0;

      &:not(:nth-child(3n)) {
        margin-right: 0;
      }

      &:nth-child(odd) {
        margin-right: 5%;
      }
    }

    &__present-photo {
      @include margin-bottom(map-get($spacers, 4));
    }
  }

  // ——————————————————————————————
  // XXS
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-xs')) {
    &__item {
      flex: 0 1 80%;
      margin-left: auto;
      margin-right: auto !important;
    }

    &__present-cta {
      flex-flow: column;

      ::v-deep .price {
        @include margin-bottom(map-get($spacers, 4));
      }
    }
  }

  // ——————————————————————————————
  // XS
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-xs')) and (max-width: map-get($proposal-page, 'viewport-sm')) {

  }

  // ——————————————————————————————
  // SM
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-sm')) and (max-width: map-get($proposal-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // MD
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-md')) and (max-width: map-get($proposal-page, 'viewport-lg')) {
  }
}
</style>
